import React from 'react'
import { Product, UsersOrdersProducts } from '@/src/types/api-types'
import { ProductsBasket } from '@/type/basket'
import FONTS from '@/src/fonts'
import COLORS from '@/src/colors'
import Link from '@/components/Common/Link'
import Highlight from '@/components/Search/Highlight'
import HighlightText from '@/components/Search/HighlightText'

type BaseProduct = Product | ProductsBasket | UsersOrdersProducts
type ProductWithHighlight = BaseProduct & { _highlightResult?: Record<string, any> }

type Props = {
  product: ProductWithHighlight
  className?: string
  enableHighlight?: boolean
}

const BrandNameLink: React.FC<Props> = ({ product, className = '', enableHighlight = false }) => {
  const brand_name = product?.brand_name

  if (!brand_name) return null

  // `brand_name`, `brand_seo_name` et `brand_variant_id` sont trois champs
  // independamment optionnels (cf. Product / UsersOrdersProducts) : un produit de
  // commande ou de panier peut porter le libelle de la marque sans aucun
  // identifiant de marque. `mapHitToProduct` aplatit en plus les identifiants
  // absents en chaine vide. Sans identifiant, `getRoutes` interpolait quand meme la
  // valeur dans l'URL (`as.replace('[slug]', undefined)` -> la chaine "undefined"),
  // produisant le lien mort /<locale>/brand/undefined, qui remontait en
  // "404 : undefined brand <user_id>". On ne rend donc le lien que si un slug
  // exploitable existe ; sinon le nom de la marque reste affiche, sans navigation.
  const brandSlug = product?.brand_seo_name || product?.brand_variant_id || null

  const label = (
    <div
      className={className}
      style={{ fontWeight: FONTS.WEIGHT.BOLD, color: COLORS.brand, fontSize: 14 }}
    >
      {enableHighlight ? (
        product?._highlightResult ? (
          <Highlight hit={product} attribute="brand_name" />
        ) : (
          <HighlightText text={brand_name} />
        )
      ) : (
        brand_name
      )}
    </div>
  )

  if (!brandSlug) return label

  return (
    <Link route={'Brand'} values={{ '[slug]': brandSlug }}>
      {label}
    </Link>
  )
}

export default BrandNameLink
